import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Tooltip } from 'recharts';
import { hex2rgba } from 'src/utils/colors';
const barColors = {
  Paid: hex2rgba('#259D58', 0.5),
  Credited: hex2rgba('#2A85D1', 0.5),
  Unpaid: hex2rgba('#C43131', 0.5)
};
const CustomTooltip = _ref => {
  let active = _ref.active,
    payload = _ref.payload;
  if (active && payload && payload.length && payload[0].dataKey !== 'gap') {
    const paid = payload.find(i => i.dataKey === 'totalPaid');
    const credited = payload.find(i => i.dataKey === 'totalCredited');
    const unpaid = payload.find(i => i.dataKey === 'totalUnpaid');
    return /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: '#212934',
        border: '1px solid #212934',
        padding: '5px',
        margin: 0,
        marginLeft: '-10px'
      }
    }, unpaid && /*#__PURE__*/React.createElement("p", {
      style: {
        padding: 0,
        margin: 0,
        color: '#ffffff'
      }
    }, "Unpaid: ", /*#__PURE__*/React.createElement("b", null, "$", "".concat(Number(unpaid.value).toFixed(2)))), credited && /*#__PURE__*/React.createElement("p", {
      style: {
        padding: 0,
        margin: 0,
        color: '#ffffff'
      }
    }, "Credited: ", /*#__PURE__*/React.createElement("b", null, "$", "".concat(Number(credited.value).toFixed(2)))), paid && /*#__PURE__*/React.createElement("p", {
      style: {
        padding: 0,
        margin: 0,
        color: '#ffffff'
      }
    }, "Reimbursed: ", /*#__PURE__*/React.createElement("b", null, "$", "".concat(Number(paid.value).toFixed(2)))));
  }
  return null;
};
const getGapSize = data => {
  return Number(((Number(data.totalPaid) + Number(data.totalCredited) + Number(data.totalUnpaid)) / 100 / 4).toFixed(2));
};
export default class SoloBarChart extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data.map(i => {
        return _objectSpread({
          gap: getGapSize(i)
        }, i);
      })
    };
  }
  render() {
    var _this$state$data$, _this$state$data$2, _this$state$data$3;
    return /*#__PURE__*/React.createElement(ResponsiveContainer, {
      width: "100%",
      height: "100%",
      minHeight: '50px'
    }, /*#__PURE__*/React.createElement(BarChart, {
      data: this.state.data,
      margin: {
        top: 10,
        right: 0,
        left: 0,
        bottom: 5
      },
      layout: "vertical",
      isAnimationActive: false,
      barSize: 26,
      scale: "point",
      barGap: 4
    }, /*#__PURE__*/React.createElement(XAxis, {
      type: "number",
      hide: true,
      axisLine: false,
      tickLine: false,
      width: 100,
      domain: ['dataMin', 'dataMax']
    }), /*#__PURE__*/React.createElement(YAxis, {
      type: "category",
      hide: true,
      axisLine: false,
      tickLine: false,
      dataKey: "name",
      margin: {
        right: '-20px'
      }
    }), ((_this$state$data$ = this.state.data[0]) === null || _this$state$data$ === void 0 ? void 0 : _this$state$data$.totalPaid) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Bar, {
      id: 'totalPaid',
      dataKey: 'totalPaid',
      stackId: "a",
      fill: barColors.Paid,
      isAnimationActive: false
    }), /*#__PURE__*/React.createElement(Bar, {
      id: "gap_1",
      dataKey: "gap",
      stackId: "a",
      fill: "transparent",
      isAnimationActive: false
    })), ((_this$state$data$2 = this.state.data[0]) === null || _this$state$data$2 === void 0 ? void 0 : _this$state$data$2.totalCredited) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Bar, {
      id: 'totalCredited',
      dataKey: 'totalCredited',
      stackId: "a",
      fill: barColors.Credited,
      isAnimationActive: false
    }), /*#__PURE__*/React.createElement(Bar, {
      id: "gap_2",
      dataKey: "gap",
      stackId: "a",
      fill: "transparent",
      isAnimationActive: false
    })), ((_this$state$data$3 = this.state.data[0]) === null || _this$state$data$3 === void 0 ? void 0 : _this$state$data$3.totalUnpaid) > 0 && /*#__PURE__*/React.createElement(Bar, {
      id: 'totalUnpaid',
      dataKey: 'totalUnpaid',
      stackId: "a",
      fill: barColors.Unpaid,
      isAnimationActive: false
    }), /*#__PURE__*/React.createElement(Tooltip, {
      offset: -50,
      shared: false,
      content: /*#__PURE__*/React.createElement(CustomTooltip, null),
      cursor: {
        fill: 'transparent'
      },
      allowEscapeViewBox: {
        x: true,
        y: true
      }
    })));
  }
}